module.exports = __webpack_public_path__ + "img/80 overflow-hidden1.825a601b.png";